import { DEFAULT_PAGINATION } from '@constants/tableConstants'
import { useLoadingStatus, useUpdateEffect } from '@utils/hooks'
import queryString from 'query-string'
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import AutoRowDetails from './AutoRowDetails'
import Table from './Table'

const ZeronDataTable = ({
	columns = [],
	initialTableData = [],
	apiFuncService = () => {},
	disableSearchBy,
	apiFuncQueryParams = {},
	disableFilter,
	enableCustomRestructureResponse = false,
	handleRestructureResponse = (data) => data,
	hiddenKeysForRowDetails = [],
	renderRowDetailsHeading,
	detailsOnRowClick,
	isCustomRowClick=false,
	customRowClickHandler=() => {},
	reformatRowDetailsForDrawer,
	...props
}) => {
	const [noData, setNoData] = React.useState(false)
	const [sorting, setSorting] = React.useState([])
	const [data, setData] = React.useState(initialTableData)

	const { loading, startLoading, stopLoading } = useLoadingStatus()
	const reloadToken = useSelector((state) => state.reloadToken)
	const [tablePaginationInfo, setTablePaginationInfo] = React.useState(DEFAULT_PAGINATION)
	const [openRowDetailsDrawer, setOpenRowDetailsDrawer] = useState(false)
	const [rowDetails, setRowDetails] = useState({})
	// eslint-disable-next-line no-unused-vars
	const [totalSize, setTotalSize] = useState(0)

	const { searchBy, searchQuery } = useMemo(() => queryString.parseUrl(window.location.href).query, [window.location.href])
	const [searchField, setSearchField] = React.useState({
		searchBy: searchBy ? searchBy : '',
		text: searchQuery ? searchQuery : ''
	})
	const updatePage = () => {
		setTablePaginationInfo((state) => {
			return {
				...state,
				page: state.page + 1
			}
		})
	}

	const onRowClickCustomHandler = (state) => () => {
		setOpenRowDetailsDrawer(true)
		setRowDetails(typeof reformatRowDetailsForDrawer === 'function' ? reformatRowDetailsForDrawer(state) : state)
	}

	const onCustomRowClickHandler = ( state ) => () => {
		customRowClickHandler(state)
	}

	const handleCloseRowDetails = () => {
		setOpenRowDetailsDrawer(false)
	}

	const setStateFromResponse = (response, reset) => {
		stopLoading()
		if (response) {
			if (!response.error) {
				if (response?.results && response?.results?.total) {
					setTotalSize(response?.results?.total)
				}
				const items = response?.results?.data
					? enableCustomRestructureResponse
						? handleRestructureResponse(response.results.data)
						: response.results.data
					: []
				if (!reset && tablePaginationInfo.page > 1) {
					return setData((state) => state.concat(items))
				}

				setData(items)
			} else {
				if (tablePaginationInfo.page === DEFAULT_PAGINATION.page) {
					setTotalSize(0)
				}
			}
		}
	}

	const getSortKey = () => {
		const key = columns.find((col) => col.name === sorting[0].id).sortKey

		return `${sorting[0].desc ? '' : '-'}${key}`
	}

	const fetchData = (reset) => {
		if (reset) {
			setTablePaginationInfo(DEFAULT_PAGINATION)
			setData([])
		}

		const params = {
			...apiFuncQueryParams,
			page: reset ? DEFAULT_PAGINATION.page : tablePaginationInfo.page,
			page_size: reset ? DEFAULT_PAGINATION.rowsPerPage : tablePaginationInfo.rowsPerPage
		}

		if (searchField.text.length > 0) {
			params[searchField.searchBy] = searchField.text
		}

		if (sorting.length > 0) {
			params.sort_by = getSortKey()
		}

		startLoading()
		const apiFunc = apiFuncService()
		apiFunc
			.api({
				params
			})
			.then((response) => {
				setStateFromResponse(response, reset)
			})

		return apiFunc
	}

	const refreshState = () => {
		setData([])
		setNoData(false)
		setSearchField({
			searchBy: '',
			text: ''
		})
		setTablePaginationInfo(DEFAULT_PAGINATION)
	}

	const resetSearchResult = () => {
		setNoData(false)
		setSearchField({
			searchBy: '',
			text: ''
		})
		setTablePaginationInfo(DEFAULT_PAGINATION)
	}

	const fetchOnSearch = (searchBy, searchText) => {
		// setData([])
		// setSearchField({
		// 	searchBy,
		// 	text: searchText
		// })
		// setTablePaginationInfo(DEFAULT_PAGINATION)
		// ----------------------------
		setNoData(false)
		setData([])
		startLoading()
		const queryForSearch = {
			searchBy,
			searchText
		}

		console.log({ queryForSearch })

		startLoading()
		const apiFunc = apiFuncService()
		const params = {
			...apiFuncQueryParams,
			[queryForSearch.searchBy]: queryForSearch.searchText,
			page: DEFAULT_PAGINATION.page,
			page_size: DEFAULT_PAGINATION.rowsPerPage
		}

		if (sorting.length > 0) {
			params.sort_by = getSortKey()
		}

		apiFunc
			.api({ params })
			.then((response) => {
				setStateFromResponse(response, true)
				setSearchField({
					searchBy,
					text: searchText
				})
				setTablePaginationInfo(DEFAULT_PAGINATION)
			})
			.catch(() => {
				stopLoading()
			})
		return apiFunc
	}

	React.useEffect(() => {
		refreshState()
		const requestToken = fetchData(true)

		return () => {
			requestToken.cancel()
		}
	}, [reloadToken, apiFuncService, JSON.stringify(apiFuncQueryParams), JSON.stringify(sorting)])

	useUpdateEffect(() => {
		if (tablePaginationInfo.page > 0) {
			const requestToken = fetchData()

			return () => {
				requestToken.cancel()
			}
		}
	}, [JSON.stringify(tablePaginationInfo), searchField, sorting])

	return (
		<>
			<Table
				columns={columns}
				data={data}
				totalSize={data.length === 0 ? 0 : totalSize < data.length ? data.length : totalSize}
				// totalSize={data?.length}
				fetchMore={updatePage}
				loading={loading}
				setSorting={setSorting}
				sorting={sorting}
				fetchOnSearch={fetchOnSearch}
				disableSearchBy={disableSearchBy}
				resetSearchResult={resetSearchResult}
				isEmpty={noData}
				disableFilter={disableFilter}
				options={{
					manualSorting: true
				}}
				showLoadMoreButton
				disableGroupBy={true}
				enableRowClick={detailsOnRowClick}
				onRowClickCustomHandler={isCustomRowClick ? onCustomRowClickHandler : onRowClickCustomHandler}
				{...props}
			/>
			{detailsOnRowClick && (
				<AutoRowDetails
					handleClose={handleCloseRowDetails}
					hiddenKeysForRowDetails={hiddenKeysForRowDetails}
					openDrawer={openRowDetailsDrawer}
					renderRowDetailsHeading={renderRowDetailsHeading}
					rowDetails={rowDetails}
					useAggregationsData
				/>
			)}
		</>
	)
}

export default ZeronDataTable
